import styled from 'styled-components';

export const PageContentContainer = styled.div``;
